import { TypographyProps } from '@mui/material';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import { MINDTICKLE_PRIVACY_POLICY } from '../../lib/Organization';
import { useI18n } from '../../lib/hook/useI18n';
import { isVendorMode } from '../../lib/Vendor';
import OrganizationsStore from '../../stores/observables/OrganizationsStore';
import Link from '../Link';
import { formatUrl } from '../../lib/String';

const useStyles = makeStyles(() => ({
  underline: {
    textDecoration: 'underline',
  },
}));

interface Props {
  color?: TypographyProps['color'];
  privacyPolicyName?: string;
  variant?: TypographyProps['variant'];
}

const PrivacyPolicyLink: React.FC<Props> = (props: Props): JSX.Element => {
  const { t } = useI18n();
  const classes = useStyles();

  const isVendor = isVendorMode();
  const shouldUseUnifiedConsent = isVendor;

  const { color, privacyPolicyName, variant = 'body2' } = props;

  const organization = OrganizationsStore.getCurrentOrganization();
  const vendor = organization?.vendor;

  // just to avoid issues with TS, but this is always available
  if (!vendor) {
    return <></>;
  }

  const privacyName =
    privacyPolicyName || organization.privacyPolicyName || t('privacy_policy');
  const vendorPrivacyPolicy =
    organization.privacyPolicyLink ||
    vendor.privacyPolicyLink ||
    MINDTICKLE_PRIVACY_POLICY;

  return (
    <Link
      className={classNames({
        [classes.underline]: shouldUseUnifiedConsent,
      })}
      color={color}
      component="span"
      href={formatUrl(vendorPrivacyPolicy)}
      text={privacyName}
      variant={variant}
    />
  );
};

export default PrivacyPolicyLink;
